import React from 'react';

import ButtonIcons from '@src/Components/Atoms/ButtonIcons/ButtonIcons';

import styles from './TooltipConsole.module.scss';
import { useTooltipConsole } from './useTooltipConsole';

const TooltipConsole: React.FC = () => {
  const { consoleRef, contentText, handleAction } = useTooltipConsole();

  return (
    <div
      data-testid={`tooltip-console`}
      className={styles['tooltip-console__containers']}
      ref={consoleRef}
    >
      <button
        className={styles['tooltip-console__button-icons']}
        onClick={() => handleAction('button')}
      >
        <img src="/assets/icons/terminal.png" alt="icon-terminal" />
      </button>

      <section className={styles['tooltip-console__section-console']}>
        <header>
          <h4>Console</h4>
          <div>
            <ButtonIcons
              onClick={() => handleAction('minimize')}
              typeIcons="minimize"
            />
            <ButtonIcons
              onClick={() => handleAction('restore')}
              typeIcons="restore"
            />
            <ButtonIcons
              onClick={() => handleAction('close')}
              typeIcons="close"
            />
          </div>
        </header>

        <div className={styles['tooltip-console__pre-list']}>
          <pre>
            {contentText.map((line, index) => (
              <p key={Number(index)}>{line}</p>
            ))}
          </pre>
        </div>
      </section>
    </div>
  );
};

export default TooltipConsole;
